<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <ContactInformationFormPart @change="onChange" @result="onResult" />

      <LeadSubmitFormPart
        ref="leadSubmit"
        :is-optional="true"
        hidden
        @change="onChange"
        @leadPostError="onLeadPostError"
        @leadPostInvalid="onLeadPostInvalid"
        @leadPostValid="onLeadPostValid"
        @result="onResult"
      />
    </t-form>

    <FormErrorMessages
      v-if="errorMessages.length"
      :error-messages="customErrorMessage"
    />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import usesReachedContactFormTracking from 'chimera/all/mixins/usesReachedContactFormTracking'
import LeadSubmitFormPart from 'chimera/all/components/form/parts/LeadSubmitFormPart'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import ErrorPage from 'chimera/all/themes/blueflow/page/ErrorPage'
import ContactInformationFormPart from 'chimera/moving/components/form/parts/contactInformation/ContactInformationFormPart'
import ThankYouPage from '~/pages/offertes-aanvragen/aanvraag-afgerond'

export default {
  name: 'ContactInformationFormStep',

  components: {
    ContactInformationFormPart,
    LeadSubmitFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  mixins: [usesReachedContactFormTracking],

  /**
   * @returns {object}
   */
  data() {
    return {
      willTransitionOnValid: true,
      customErrorMessage: ['Controleer je gegevens'],
    }
  },

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Perform lead post.
     * Based on inner logic of `postLead` the callback will be in `onLeadPost*` methods.
     */
    transition() {
      this.$refs.leadSubmit.postLead()
    },

    /**
     * On successful lead post
     */
    onLeadPostValid() {
      this.routeTo(ThankYouPage)
    },

    /**
     * On invalid lead post
     */
    onLeadPostInvalid() {
      this.routeTo(ErrorPage)
    },

    /**
     * Lead post resulted in an error
     */
    onLeadPostError() {
      this.routeTo(ErrorPage)
    },
  },
}
</script>
